import {lazy, Suspense, useEffect, useState} from "react";
import {Footer} from "./components/Footer";
import {Header} from "./components/Header";
import {AnalyticsConsent} from "./components/AnalyticsConsent";
import {HomePage} from "./pages/HomePage";
import {getSeoPage, normalizePath} from "./seo";
import {applySeoHead} from "./seoHead";
import "./App.scss";

const ContactPage = lazy(() => import("./pages/ContactPage").then(module => ({default: module.ContactPage})));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage").then(module => ({default: module.PrivacyPage})));
const ArticlesPage = lazy(() => import("./pages/ArticlesPage").then(module => ({default: module.ArticlesPage})));
const GermanicPage = lazy(() => import("./pages/GermanicPage").then(module => ({default: module.GermanicPage})));
const PersonocratiaPage = lazy(() => import("./pages/PersonocratiaPage").then(module => ({default: module.PersonocratiaPage})));
const TestimonialsPage = lazy(() => import("./pages/TestimonialsPage").then(module => ({default: module.TestimonialsPage})));
const WorkshopsPage = lazy(() => import("./pages/WorkshopsPage").then(module => ({default: module.WorkshopsPage})));

function currentLocation() {
  return {route: normalizePath(window.location.pathname), query: new URLSearchParams(window.location.search)};
}

function App() {
  const [showAnalyticsChoices, setShowAnalyticsChoices] = useState(false);
  const location = currentLocation();
  const queryKey = location.query.toString();
  const pageTitle = getSeoPage(location.route)?.title || "AUPPS Personocrația";

  useEffect(() => {
    applySeoHead(location.route);
    window.scrollTo(0, 0);
  }, [location.route, queryKey]);

  let page;
  switch (location.route) {
    case "/":
      page = <HomePage/>;
      break;
    case "/despre-noi/":
      page = <HomePage aboutOnly/>;
      break;
    case "/ateliere/":
      page = <WorkshopsPage query={location.query}/>;
      break;
    case "/articole/":
      page = <ArticlesPage/>;
      break;
    case "/personocratia/":
      page = <PersonocratiaPage/>;
      break;
    case "/stiinta-vindecarii-germanice/":
      page = <GermanicPage/>;
      break;
    case "/testimoniale/":
      page = <TestimonialsPage/>;
      break;
    case "/contact/":
      page = <ContactPage key={location.query.toString()} query={location.query}/>;
      break;
    case "/politica-de-confidentialitate/":
      page = <PrivacyPage onOpenCookiePreferences={() => setShowAnalyticsChoices(true)}/>;
      break;
    default:
      if (location.route.startsWith("/articole/") && getSeoPage(location.route)?.kind === "article") {
        const slug = decodeURIComponent(location.route.split("/")[2]);
        page = <ArticlesPage selectedSlug={slug}/>;
      } else {
        page = <div className="page-container"><h1>Pagina nu a fost găsită</h1><a href="/">Înapoi acasă</a></div>;
      }
  }

  return (
    <>
      <button
        className="skip-link"
        type="button"
        onClick={() => document.getElementById("main-content")?.focus()}
      >
        Sari la conținut
      </button>
      <Header route={location.route}/>
      <main id="main-content" tabIndex={-1}>
        <Suspense fallback={<div className="page-container" role="status">Se încarcă pagina…</div>}>
          {page}
        </Suspense>
      </main>
      <Footer/>
      <AnalyticsConsent pageTitle={pageTitle} pageKey={`${location.route}?${queryKey}`}
                        showChoices={showAnalyticsChoices} onCloseChoices={() => setShowAnalyticsChoices(false)}/>
    </>
  );
}

export default App;
